import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapResponsiveContentSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapresponsivecontenttext: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      definingForContent: true,
      parseDOM: [{
        tag: 'MadCap\\:responsiveContentText',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:responsiveContentText'
    },

    madcapresponsivecontentitem: {
      group: 'inline',
      inline: true,
      content: 'inline*',
      definingForContent: true,
      parseDOM: [{
        tag: 'MadCap\\:responsiveContentItem',
        preserveWhitespace: true
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:responsiveContentItem'
    },
  } satisfies Record<string, NodeSpec>;
}
